import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../../DesignSystem/colors';
const baseSize = '24px';
const scaleFactorVals = {
    s: 0.5,
    m: 1,
    l: 1.5,
};
const spinnerAnimation = keyframes `0% { opacity: 1; } 100% { opacity: 0; }`;
const Spinner = styled.div `
  --spinner-scale-factor: ${({ size }) => scaleFactorVals[size || 'm']};
  width: calc(${baseSize} * var(--spinner-scale-factor));
  height: calc(${baseSize} * var(--spinner-scale-factor));
  margin: auto;
  position: relative;

  & > div {
    background: ${({ color, light }) => color ? color : light ? 'white' : colors.content.onBackground};
  }
`;
const SpinnerItem = styled.div `
  animation: ${spinnerAnimation} 0.8s linear infinite;
  height: calc(5px * var(--spinner-scale-factor));
  width: calc(2px * var(--spinner-scale-factor));
  border-radius: calc(3px * var(--spinner-scale-factor));
  position: absolute;
  top: 50%;
  left: calc(50% - (1.5px * var(--spinner-scale-factor)));
  transform: translate(-50%, -50%) scale(var(--spinner-scale-factor));

  &:nth-child(1) {
    transform-origin: center top;
    transform: rotate(0deg)
      translateY(calc(-10px * var(--spinner-scale-factor)));
    animation-delay: -0.7s;
  }

  &:nth-child(2) {
    transform-origin: center top;
    transform: rotate(45deg)
      translateY(calc(-10px * var(--spinner-scale-factor)));
    animation-delay: -0.6s;
  }

  &:nth-child(3) {
    transform-origin: center top;
    transform: rotate(90deg)
      translateY(calc(-10px * var(--spinner-scale-factor)));
    animation-delay: -0.5s;
  }

  &:nth-child(4) {
    transform-origin: center top;
    transform: rotate(135deg)
      translateY(calc(-10px * var(--spinner-scale-factor)));
    animation-delay: -0.4s;
  }

  &:nth-child(5) {
    transform-origin: center top;
    transform: rotate(180deg)
      translateY(calc(-10px * var(--spinner-scale-factor)));
    animation-delay: -0.3s;
  }

  &:nth-child(6) {
    transform-origin: center top;
    transform: rotate(225deg)
      translateY(calc(-10px * var(--spinner-scale-factor)));
    animation-delay: -0.2s;
  }

  &:nth-child(7) {
    transform-origin: center top;
    transform: rotate(270deg)
      translateY(calc(-10px * var(--spinner-scale-factor)));
    animation-delay: -0.1s;
  }

  &:nth-child(8) {
    transform-origin: center top;
    transform: rotate(315deg)
      translateY(calc(-10px * var(--spinner-scale-factor)));
    animation-delay: 0s;
  }
`;
export default function ImpSpinner({ size, light, color }) {
    return (React.createElement(Spinner, { size: size, light: light, color: color, "data-testid": "spinner" },
        React.createElement(SpinnerItem, null),
        React.createElement(SpinnerItem, null),
        React.createElement(SpinnerItem, null),
        React.createElement(SpinnerItem, null),
        React.createElement(SpinnerItem, null),
        React.createElement(SpinnerItem, null),
        React.createElement(SpinnerItem, null),
        React.createElement(SpinnerItem, null)));
}
//# sourceMappingURL=ImpSpinner.js.map